export default "__VITE_ASSET__BylxJWwb__"